import React from 'react';

import styled from 'styled-components';
import LineLeftQuotedComponent from './LineLeftQuotedComponent';
import TurnRightIcon from '@mui/icons-material/TurnRight';
import TurnLeftIcon from '@mui/icons-material/TurnLeft';
var moment = require('moment-timezone');
const Balloon = styled.div`
position:relative;
    padding:0px;
    margin-top:15px;
`;
const Faceicon = styled.div`
    float: left;
        margin-right: -50px;
        width: 40px;
`;
const FaceiconImg = styled.img`
    width: 100%;
        height: auto;
        border-radius: 50%;
`;
const DisplayName = styled.div`
    margin:0 0 0 50px;
    font-size:9px;
    font-weight:bold;
    color:#FFF;
text-align:left;
`;
const Chatting = styled.div`
    width: 100%;
        text-align: left;
`;
const Say = styled.div`
    display: inline-block;
    position: relative; 
    margin: 0 0 0 50px;
    padding: 5px;
    max-width: 250px;
    border-radius: 12px;
    margin-bottom: 2px;
`;

const SayP = styled.p`
    margin:0；
    height:270px;
`;

const MsgArea = styled.p`
    margin: 0;
        padding: 0;
word-wrap: break-word;
`;
const Time = styled.div`
    display: inline-block;
    position: relative; 
    margin: 0 0 0 5px;
    position: absolute;bottom: 0px;
    font-size:10px;
    color:#FFF;
`;

const Right = styled.div`
    display: inline-block;
    position: relative; 
    margin: 0 0 0 5px;
    position: absolute;
    bottom: 0px;
    font-size:10px;
    color:#FFF;
    width:100px;
`;

const Download = styled.div`
    display: inline-block;
    position: relative; 
    margin: 0 0 0 5px;
    position: absolute;
    bottom: 5px;
    font-size:10px;
    color:#FFF;
`;



export default class LineImgComponent extends React.Component {
    constructor(props) {
        super(props)
        const dt = new Date(this.props.msg.date)
        this.state = {
            date_time: (dt.getMonth() + 1) + "/" + dt.getDate() + " " + dt.getHours() + ":" + dt.getMinutes(),

        };

    }

    render() {
        return (
            <Balloon className="col-xs-12" >
                <Faceicon><FaceiconImg src={'https://img.global-center.co.jp/v1/line/img/' + this.props.msg.line_user_id + '/200/200'} /></Faceicon>
                <DisplayName>{this.props.msg.display_name}</DisplayName>
                <Chatting>
                    <Say>
                        {this.props.msg.quoted_message_id && this.props.msg.quoted_line ? 

                            <>
                                <div style={{backgroundColor: "white", borderRadius:"12px"}}>
                                    <LineLeftQuotedComponent msg={this.props.msg.quoted_line} type={"sticker"}/>
                                    
                                </div>
                                <TurnLeftIcon sx={{transform: "rotate(180deg)"}}/>
                            </>
                        :this.props.msg.quoted_message_id && !this.props.msg.quoted_line ? 
                            <>
                                <div style={{fontSize:"9px", padding:"10px 10px 10px 10px",borderBottom:"1px solid #dcdcdc",backgroundColor:"white", borderRadius:"12px"}}>引用先不明</div>
                                <TurnLeftIcon sx={{transform: "rotate(180deg)"}}/>
                            </>
                            :
                            ""
                        }

                        <div>
                            <img src={"https://stickershop.line-scdn.net/stickershop/v1/sticker/"+this.props.msg.message_text+"/iPhone/sticker_key@2x.png"} />
                        </div>
                    </Say>
                    <Time>{moment.utc(this.props.msg.date).format('MM/DD HH:mm')}</Time>
                </Chatting>
            </Balloon>
        );
    }
}
